import { EventEmitter, Injectable } from '@angular/core';
import {
    MatSnackBarConfig,
    MatSnackBarHorizontalPosition,
    MatSnackBarVerticalPosition,
} from '@angular/material/snack-bar';

export interface SnackBarConfig extends MatSnackBarConfig {
    verticalPosition?: MatSnackBarVerticalPosition;
    horizontalPosition?: MatSnackBarHorizontalPosition;
    data: {
        message: string;
        message2?: string;
        dismiss_text?: string;
        duration?: number;
        type: 'error' | 'success' | 'info';
        panelClass?: string[];
    };
}

@Injectable({
    providedIn: 'root',
})
export class SnackbarService {
    public snack$ = new EventEmitter<any>();
    public dismiss$ = new EventEmitter<any>();
    timeOut: any;

    constructor() {}

    scheduleDismiss(duration = 4000): void {
        if (duration === 0) return; // 0 means persistent - no auto-dismiss
        this.timeOut = setTimeout(() => {
            this.dismiss();
        }, duration);
    }

    open(config: SnackBarConfig): void {
        if (config.data.type === 'error') {
            config.panelClass = [...(config.panelClass || []), 'error'];
        } else if (config.data.type === 'success') {
            config.panelClass = [...(config.panelClass || []), 'success'];
        } else if (config.data.type === 'info') {
            config.panelClass = [...(config.panelClass || []), 'info'];
        }

        this.snack$.emit(config);
        this.scheduleDismiss(config.data.duration);
    }

    dismiss() {
        this.dismiss$.emit();
        clearTimeout(this.timeOut);
    }

    success(title, desc?) {
        this.snack$.emit({
            data: {
                message: title,
                message2: desc,
                // dismiss_text?: string
                duration: 4000,
                type: 'success',
                panelClass: ['success'],
            },
        });
    }

    error(title, desc?, duration = 15000) {
        this.snack$.emit({
            data: {
                message: title,
                message2: desc,
                // dismiss_text?: string
                duration,
                type: 'error',
                panelClass: ['error'],
            },
        });
    }

    info(title, desc?, duration = 15000) {
        this.snack$.emit({
            data: {
                message: title,
                message2: desc,
                // dismiss_text?: string
                duration,
                type: 'info',
                panelClass: ['info'],
            },
        });
    }

    fixedError({ title, desc, duration }: { title: string; desc: string; duration?: number }) {
        this.open({
            panelClass: ['overlay-large-right', 'error'],
            data: {
                message: title,
                message2: desc,
                type: 'error',
                duration,
            },
        });
    }
}
